var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.prizeList.length > 0)?_c('Component',{attrs:{"is-edit":false}},[_c('Main',{attrs:{"list":_vm.state.prizeList,"handle-click":_vm.handleClick}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }